import { Box, Link, List, ListItem, ListItemText, Typography } from '@mui/material';
import { getContactEmail } from '../../utils/env';

const ContactPage = () => {
  const contactEmail = getContactEmail();
  const whatsappDisplay = '+55 11925758584';
  const whatsappUrl = 'https://wa.me/5511925758584';

  return (
    <Box display="flex" flexDirection="column" gap={3}>
      <Typography variant="h4" fontWeight={700} gutterBottom>
        Contato
      </Typography>
      <Typography color="text.secondary">
        Precisa de ajuda ou tem dúvidas? Fale com a gente pelos canais abaixo.
      </Typography>
      <List dense>
        <ListItem>
          <ListItemText
            primary={
              <>
                E-mail: <Link href={`mailto:${contactEmail}`}>{contactEmail}</Link>
              </>
            }
          />
        </ListItem>
        <ListItem>
          <ListItemText primary="Horário: segunda a sexta, 9h às 18h (BRT)" />
        </ListItem>
        <ListItem>
          <ListItemText
            primary={
              <>
                WhatsApp:{' '}
                <Link href={whatsappUrl} target="_blank" rel="noopener noreferrer">
                  {whatsappDisplay}
                </Link>
              </>
            }
          />
        </ListItem>
      </List>
      <Box>
        <Link href={whatsappUrl} target="_blank" rel="noopener noreferrer" underline="hover">
          Falar no WhatsApp agora
        </Link>
      </Box>
      <Typography color="text.secondary">
        Para relatos de segurança ou abuso, inclua o e-mail envolvido e prints/cabeçalhos relevantes
        para investigarmos rapidamente.
      </Typography>
    </Box>
  );
};

export default ContactPage;
